"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbeddingStatusType = void 0;
/**
 * 向量化状态
 */
var EmbeddingStatusType;
(function (EmbeddingStatusType) {
    EmbeddingStatusType["UPLOADING"] = "Uploading";
    EmbeddingStatusType["NEW"] = "New";
    EmbeddingStatusType["LOADING"] = "Loading";
    EmbeddingStatusType["FAILURE"] = "Failure";
    EmbeddingStatusType["READY"] = "Ready";
})(EmbeddingStatusType = exports.EmbeddingStatusType || (exports.EmbeddingStatusType = {}));
